import roundAbnt from './roundAbnt';

const formatNumberToCurrency = (value: number): string => {
  return `R$ ${roundAbnt(value).toLocaleString('pt-Br', {
    minimumFractionDigits: 2,
  })}`;
};

export default formatNumberToCurrency;
